/**
 * A game is open when the URL says `?game=<id>` — a refresh lands back in it, and Back leaves it. The rest of the
 * app's URL state (urlState.ts) keeps params it does not own, so a game rides on top of whatever is selected.
 */
const GAME_PARAM = 'game'
const GAME_EVENT = 'avg-game-nav'

export function openGameId(): string | null {
  const id = new URLSearchParams(window.location.search).get(GAME_PARAM)
  return id && /^[0-9a-f]{16}$/.test(id) ? id : null
}

export function openGame(id: string): void {
  const q = new URLSearchParams(window.location.search)
  if (q.get(GAME_PARAM) === id) return
  q.set(GAME_PARAM, id)
  window.history.pushState(window.history.state, '', `${window.location.pathname}?${q}${window.location.hash}`)
  window.dispatchEvent(new Event(GAME_EVENT))
}

export function closeGame(): void {
  const q = new URLSearchParams(window.location.search)
  if (!q.has(GAME_PARAM)) return
  q.delete(GAME_PARAM)
  const s = q.toString()
  window.history.replaceState(window.history.state, '', `${window.location.pathname}${s ? `?${s}` : ''}${window.location.hash}`)
  window.dispatchEvent(new Event(GAME_EVENT))
}

/** Call `fn` whenever the open game may have changed (opened, closed, Back/Forward). */
export function onGameNav(fn: () => void): () => void {
  window.addEventListener('popstate', fn)
  window.addEventListener(GAME_EVENT, fn)
  return () => {
    window.removeEventListener('popstate', fn)
    window.removeEventListener(GAME_EVENT, fn)
  }
}

/**
 * What a game id is — a board's or a mahjong table's — when this app has already seen it (a list, a frame, one it
 * made), so opening it needs no question first. An id it has not seen is asked about once (GameHost).
 */
const known = new Map<string, 'board' | 'mahjong'>()
export function rememberKind(id: string, kind: 'board' | 'mahjong'): void {
  known.set(id, kind)
}
export function knownKind(id: string): 'board' | 'mahjong' | undefined {
  return known.get(id)
}
